import BreadcrumbView from "../../common/breadcrumb/breadcrumb.html";
import MaterialsTypesListView from "./materials_types-list.html";
import MaterialsTypesEditView from "./materials_types-edit.html";


angular.module("materials_types", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('materials_types', {
                url: "/materials_types",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('materials_types.list', {
                url: "/list",
                controller: "MaterialsTypesListCtrl",
                template: MaterialsTypesListView,
                data: { pageTitle: 'Tipos de Materiales' },
                requiredPermission: ["MATERIAL_TYPES_READ"]
            })            
            .state('materials_types.edit', {
                url: "/edit/:id",
                controller: "MaterialsTypesEditCtrl",
                template: MaterialsTypesEditView,
                data: { pageTitle: 'Tipos de Materiales' },
                requiredPermission: ["MATERIAL_TYPES_READ"]
            })
    }])
;